var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhournal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 1.5H2.47656L1.25 9.03125C2.07549 8.21115 3.19186 7.75088 4.35547 7.75088C5.51908 7.75088 6.63545 8.21115 7.46094 9.03125C7.86911 9.43646 8.19306 9.91844 8.41413 10.4494C8.6352 10.9804 8.74902 11.5498 8.74902 12.125C8.74902 12.7002 8.6352 13.2696 8.41413 13.8006C8.19306 14.3316 7.86911 14.8135 7.46094 15.2188C6.63545 16.0388 5.51908 16.4991 4.35547 16.4991C3.19186 16.4991 2.07549 16.0388 1.25 15.2188",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhournal);
export default __webpack_public_path__ + "static/media/zhournal.c96d2dd0.svg";
export { ForwardRef as ReactComponent };